import React, { useState, useEffect, useRef } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReactPlayer from "react-player";
import "./CloudfrontVideoFormat.scss";
import ReactHlsPlayer from "react-hls-player";
import MediaService from "../services/MediaService";
import PopUp from './../Popup/logoutPopup'
import { getGPUTier } from 'detect-gpu'


const CloudfrontVideoFormat = ({
  onPlay,
  source,
  back,
  ended,
  background,
  close,
}) => {
  const popUp = useRef();
  const timer = useRef();
  const timer1 = useRef();
  const timer2 = useRef();
  const ref = useRef(null);
  // const controlBar = document.getElementById('controlBar')

  const [playing, setPlaying] = useState(true);
  const [videoReady, setVideoReady] = useState(false);

  const { login } = useSelector((state) => state.loginReducer, shallowEqual);

  const ExitImage = MediaService.getImage("/Images/close.png", login);

  const isIOS = () => {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }

  const [controls, setControls] = useState(isIOS() ? true : (!window.location.href.includes('wearefriends.cool')) ?  true : window.location.href.includes('staging') ? true : false);

  useEffect(() => {
    getGPUTier().then((rel)=>{
      if (source && source.includes('m3u8')) {
        if(rel.gpu.includes('arm')){
          if(source.includes('480.m3u8')){
            source = source.replace('480.m3u8', '1080.m3u8');
          }
          else if(source.includes('360.m3u8')){
            source = source.replace('360.m3u8', '1080.m3u8');
          }
        }
      }
      setVideoReady(true);
    });
  },[]);

  return (
    <div className="player-container-old" style={{ backgroundImage: `url(${background}` }}>
      {/* <div className="videoDiv" onMouseEnter={() => document.getElementById('controlBar').style.opacity='1'} onMouseLeave={() => document.getElementById('controlBar').style.opacity='0'}> */}
      <div className="videoDiv">
        <img
          className="back-btn-ftb"
          src={ExitImage}
          onClick={() => (close())}
        />
        <div ref={popUp} style={{display: 'none'}}>
          <PopUp 
              content={
                <>
                  <b id='title'>
                      This video requires a faster internet connection. 
                      <br />
                      If it is still freezing after 15 seconds, we will skip it for you. 
                      <br />
                      You can always watch it later in the review mode.
                      <br />
                  </b>
                  <button
                    id="logoutButton1"
                    className="logoutButton"
                    onClick={() => {
                      popUp.current.style.display = 'none';
                    }}
                  >
                    <b id="title">
                      OKAY
                    </b>
                  </button>
                </>
              }
          />
        </div>
        {/* {source.includes('m3u8') && <div id="controlBar" >
            {<img style={saveVideoBtn} src={PlayButton} alt="PlayButton" onClick={() => {
                        if(ref.current.paused){
                            ref.current.play();
                        }
                        else{
                            ref.current.pause();
                        }
                }}>
            </img>}

            {<img style={back10Sec} src={Replay} alt="backSecondsButton" onClick={() => {
                if(ref.current.currentTime < 10) {
                    ref.current.currentTime = 0
                } else {
                    ref.current.currentTime = ref.current.currentTime - 10
                }
            }}>
            </img>}
        </div>}
        {!source.includes('m3u8') && <div id="controlBar">
            {<img style={saveVideoBtn} src={PlayButton} alt="PlayButton" onClick={() => {
                    if(!playing){
                        instrumentalPlayer.current.play();
                        recordPlayer.current.play();
                    }
                    else{
                        instrumentalPlayer.current.pause();
                        recordPlayer.current.pause();
                    }
                    setPlaying(!playing)
                }}>
            </img>}

            {<img style={back10Sec} src={Replay} alt="backSecondsButton" onClick={() => {
                if(ref.current.getCurrentTime() < 10) {
                    ref.current.seekTo(0);
                    recordPlayer.current.currentTime = 0
                    instrumentalPlayer.current.currentTime = 0
                } else {
                    ref.current.seekTo(ref.current.getCurrentTime()-10);
                    recordPlayer.current.currentTime = recordPlayer.current.currentTime - 10;
                    instrumentalPlayer.current.currentTime = instrumentalPlayer.current.currentTime - 10;
                }
            }}>
            </img>}
      </div>} */}
        </div>
        {videoReady && <div className="video-container-old">
          {source && !source.includes("m3u8") ? (
            <ReactPlayer
              controls={controls}
              className="react-player-old"
              ref={ref}
              playing={playing}
              url={source.includes('https://') ? source : `${login.cloudFront}media/${source}?${login.cookie}`}
              onEnded={ended}
              onError={ended}
              onStart={() => {
                if(isIOS() && !window.location.href.includes('staging')){
                  setControls(false);
                }
              }}
              playsinline={true}
            />
          ) : (<ReactHlsPlayer
            className='hls-player'
            playerRef={ref}
            src={`${login.cloudFront}videos/${source}`}
            autoPlay={true}
            controls={controls}
            height="95%"
            // onMouseEnter={handleMouseEnter}
            // onMouseLeave={handleMouseLeave}
            playsInline={true}
            onEnded={ended}
            onError={ended}
            preload="auto"
            onWaiting={() => {
              timer2.current = setTimeout(() => {
                popUp.current.style.display = 'block';    
              }, 5000);

              timer.current = setTimeout(() => {
                ended();
              }, 15000);
            }}
            onPlaying={() => {
              if(isIOS() && !window.location.href.includes('staging')){
                setControls(false);
              }
              popUp.current.style.display = 'none';
              clearTimeout(timer.current);
              clearTimeout(timer2.current);
            }}
            hlsConfig={{
              capLevelToPlayerSize:true,
              capLevelOnFPSDrop: true,
              startLevel:-1,
              nudgeOffset: 0.1,
              nudgeMaxRetry: 10,
              maxSeekHole: 2,
              maxBufferLength: 30,
              maxBufferHole: 0.5,
              manifestLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: Infinity,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 1,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              playlistLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 10000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              fragLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 10000,
                  maxLoadTimeMs: 120000,
                  timeoutRetry: {
                    maxNumRetry: 4,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 6,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              keyLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 8000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 1,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 20000,
                    backoff: 'linear',
                  },
                  errorRetry: {
                    maxNumRetry: 8,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 20000,
                    backoff: 'linear',
                  },
                },
              },
              certLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 8000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                },
              },
              steeringManifestLoadPolicy: {
                default: {
                  maxTimeToFirstByteMs: 10000,
                  maxLoadTimeMs: 20000,
                  timeoutRetry: {
                    maxNumRetry: 2,
                    retryDelayMs: 0,
                    maxRetryDelayMs: 0,
                  },
                  errorRetry: {
                    maxNumRetry: 1,
                    retryDelayMs: 1000,
                    maxRetryDelayMs: 8000,
                  },
                }
              },
              xhrSetup: function(xhr, url) {
                if(window.location.href.includes('wearefriends.cool')){
                  xhr.withCredentials = true // send cookies
                }
                else{
                  xhr.open('GET', url + login.cookie);
                }
              }
            }}
          />)}
        </div>}
    </div>
  );
};
export { CloudfrontVideoFormat };
